import { Context } from "@nuxt/types/app";
import { get } from "lodash-es";

interface CurrentPathPlugin {
  currentPath(): void;
}

export default function (context: Context): CurrentPathPlugin {
  function currentPath(): string {
    return get(context.route, "matched[0].path", "") || "";
  }

  return { currentPath };
}
